import { defaultFilters } from '../../../../record-viewer/filters';

export const storageKey = 'column-filter-params';

export const DatePickers = ['date_filter', 'due_date'];

export const dateFilter = {
  header: 'Date Filter',
  accessor: 'date_filter',
};

export const noFilterList = [
  'delete_issue',
  'basic_issue_photos',
  'basic_task_photo',
  'title',
  'from', // linked issues
  'form_values.4ae3', // title tasks
  'created_at', // reported on
  'record_sequence', // ID column
];

export const date = [
  {
    label: 'All Time',
    value: 'All Time',
  },
  {
    label: 'Today',
    value: 'Today',
  },
  {
    label: 'Yesterday',
    value: 'Yesterday',
  },
  {
    label: 'Last 7 days',
    value: 'Last 7 days',
  },
  {
    label: 'Last 30 days',
    value: 'Last 30 days',
  },
  {
    label: 'Custom',
    value: 'Custom',
  },
];

export const dueDate = [
  {
    label: 'All Time',
    value: 'All Time',
  },
  {
    label: 'Overdue',
    value: 'Overdue',
  },
  {
    label: 'Today',
    value: 'Today',
  },
  {
    label: 'Tomorrow',
    value: 'Tomorrow',
  },
  {
    label: 'Next 7 days',
    value: 'Next 7 days',
  },
  {
    label: 'Next 30 days',
    value: 'Next 30 days',
  },
  {
    label: 'Custom',
    value: 'Custom',
  },
];

const dateValues = (() => date.map((d) => d.value))();
const dueDateValues = (() => dueDate.map((d) => d.value))();
export const StaticDateValues = [...dateValues, ...dueDateValues];

export const linkedTasks = [
  {
    label: 'No Tasks',
    value: 'No Tasks',
  },
  {
    label: 'At least 1 Task',
    value: 'At least 1 Task',
  },
  {
    label: 'All Completed Tasks',
    value: 'All Completed Tasks',
  },
];

export const baseURL = {
  basic_issue: '/issues',
  basic_task: '/tasks',
};

export {
  defaultFilters,
};
